var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("担当サーベイ一覧")]),_c('v-spacer'),_c('data-table',{attrs:{"data":_vm.answer_sheets},on:{"editItem":_vm.editItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }